/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as DebugRouteImport } from './routes/debug'
import { Route as AppSubheaderRouteRouteImport } from './routes/_app/_subheader/route'
import { Route as AppInnstillingerRouteImport } from './routes/_app/innstillinger'
import { Route as AppSelskapRouteImport } from './routes/_app/selskap'
import { Route as AppSubheaderBestillingerRouteImport } from './routes/_app/_subheader/bestillinger'
import { Route as PublicLandingIndexRouteImport } from './routes/_public/_landing/index'
import { Route as PublicLandingKundestChar248tteRouteImport } from './routes/_public/_landing/kundestøtte'
import { Route as PublicLandingValideringRouteImport } from './routes/_public/_landing/validering'
import { Route as PublicLandingVeiledningRouteImport } from './routes/_public/_landing/veiledning'
import { Route as PublicLandingVilkChar229rRouteImport } from './routes/_public/_landing/vilkår'
import { Route as PublicAuthCallbackRouteImport } from './routes/_public/auth/callback'
import { Route as PublicAuthLoggInnRouteImport } from './routes/_public/auth/logg-inn'
import { Route as PublicAuthLoginRouteImport } from './routes/_public/auth/login'
import { Route as PublicAuthLogoutRouteImport } from './routes/_public/auth/logout'
import { Route as PublicDokumentasjonEksporterRouteImport } from './routes/_public/dokumentasjon/eksporter'
import { Route as PublicDokumentasjonInnrapporteringRouteImport } from './routes/_public/dokumentasjon/innrapportering'
import { Route as AppSubheaderFjernAvtaleIndexRouteImport } from './routes/_app/_subheader/fjern-avtale/index'
import { Route as AppSubheaderMaalerdataIndexRouteImport } from './routes/_app/_subheader/maalerdata/index'
import { Route as AppSubheaderMaalerdataPeriodeRouteImport } from './routes/_app/_subheader/maalerdata/periode'
import { Route as AppSubheaderMaalerdataSimuleringRouteImport } from './routes/_app/_subheader/maalerdata/simulering'
import { Route as AppSubheaderMaalerdataValideringRouteImport } from './routes/_app/_subheader/maalerdata/validering'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const DebugRoute = DebugRouteImport.update({
  id: '/debug',
  path: '/debug',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSubheaderRouteRoute = AppSubheaderRouteRouteImport.update({
  id: '/_subheader',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppInnstillingerRoute = AppInnstillingerRouteImport.update({
  id: '/innstillinger',
  path: '/innstillinger',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSelskapRoute = AppSelskapRouteImport.update({
  id: '/selskap',
  path: '/selskap',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSubheaderBestillingerRoute =
  AppSubheaderBestillingerRouteImport.update({
    id: '/bestillinger',
    path: '/bestillinger',
    getParentRoute: () => AppSubheaderRouteRoute,
  } as any)
const PublicLandingIndexRoute = PublicLandingIndexRouteImport.update({
  id: '/_public/_landing/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicLandingKundestChar248tteRoute =
  PublicLandingKundestChar248tteRouteImport.update({
    id: '/_public/_landing/kundestøtte',
    path: '/kundestøtte',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicLandingValideringRoute = PublicLandingValideringRouteImport.update({
  id: '/_public/_landing/validering',
  path: '/validering',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicLandingVeiledningRoute = PublicLandingVeiledningRouteImport.update({
  id: '/_public/_landing/veiledning',
  path: '/veiledning',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicLandingVilkChar229rRoute =
  PublicLandingVilkChar229rRouteImport.update({
    id: '/_public/_landing/vilkår',
    path: '/vilkår',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicAuthCallbackRoute = PublicAuthCallbackRouteImport.update({
  id: '/_public/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicAuthLoggInnRoute = PublicAuthLoggInnRouteImport.update({
  id: '/_public/auth/logg-inn',
  path: '/auth/logg-inn',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicAuthLoginRoute = PublicAuthLoginRouteImport.update({
  id: '/_public/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicAuthLogoutRoute = PublicAuthLogoutRouteImport.update({
  id: '/_public/auth/logout',
  path: '/auth/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicDokumentasjonEksporterRoute =
  PublicDokumentasjonEksporterRouteImport.update({
    id: '/_public/dokumentasjon/eksporter',
    path: '/dokumentasjon/eksporter',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicDokumentasjonInnrapporteringRoute =
  PublicDokumentasjonInnrapporteringRouteImport.update({
    id: '/_public/dokumentasjon/innrapportering',
    path: '/dokumentasjon/innrapportering',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppSubheaderFjernAvtaleIndexRoute =
  AppSubheaderFjernAvtaleIndexRouteImport.update({
    id: '/fjern-avtale/',
    path: '/fjern-avtale/',
    getParentRoute: () => AppSubheaderRouteRoute,
  } as any)
const AppSubheaderMaalerdataIndexRoute =
  AppSubheaderMaalerdataIndexRouteImport.update({
    id: '/maalerdata/',
    path: '/maalerdata/',
    getParentRoute: () => AppSubheaderRouteRoute,
  } as any)
const AppSubheaderMaalerdataPeriodeRoute =
  AppSubheaderMaalerdataPeriodeRouteImport.update({
    id: '/maalerdata/periode',
    path: '/maalerdata/periode',
    getParentRoute: () => AppSubheaderRouteRoute,
  } as any)
const AppSubheaderMaalerdataSimuleringRoute =
  AppSubheaderMaalerdataSimuleringRouteImport.update({
    id: '/maalerdata/simulering',
    path: '/maalerdata/simulering',
    getParentRoute: () => AppSubheaderRouteRoute,
  } as any)
const AppSubheaderMaalerdataValideringRoute =
  AppSubheaderMaalerdataValideringRouteImport.update({
    id: '/maalerdata/validering',
    path: '/maalerdata/validering',
    getParentRoute: () => AppSubheaderRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof PublicLandingIndexRoute
  '/debug': typeof DebugRoute
  '/innstillinger': typeof AppInnstillingerRoute
  '/selskap': typeof AppSelskapRoute
  '/bestillinger': typeof AppSubheaderBestillingerRoute
  '/kundestøtte': typeof PublicLandingKundestChar248tteRoute
  '/validering': typeof PublicLandingValideringRoute
  '/veiledning': typeof PublicLandingVeiledningRoute
  '/vilkår': typeof PublicLandingVilkChar229rRoute
  '/auth/callback': typeof PublicAuthCallbackRoute
  '/auth/logg-inn': typeof PublicAuthLoggInnRoute
  '/auth/login': typeof PublicAuthLoginRoute
  '/auth/logout': typeof PublicAuthLogoutRoute
  '/dokumentasjon/eksporter': typeof PublicDokumentasjonEksporterRoute
  '/dokumentasjon/innrapportering': typeof PublicDokumentasjonInnrapporteringRoute
  '/maalerdata/periode': typeof AppSubheaderMaalerdataPeriodeRoute
  '/maalerdata/simulering': typeof AppSubheaderMaalerdataSimuleringRoute
  '/maalerdata/validering': typeof AppSubheaderMaalerdataValideringRoute
  '/fjern-avtale/': typeof AppSubheaderFjernAvtaleIndexRoute
  '/maalerdata/': typeof AppSubheaderMaalerdataIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof PublicLandingIndexRoute
  '/debug': typeof DebugRoute
  '/innstillinger': typeof AppInnstillingerRoute
  '/selskap': typeof AppSelskapRoute
  '/bestillinger': typeof AppSubheaderBestillingerRoute
  '/kundestøtte': typeof PublicLandingKundestChar248tteRoute
  '/validering': typeof PublicLandingValideringRoute
  '/veiledning': typeof PublicLandingVeiledningRoute
  '/vilkår': typeof PublicLandingVilkChar229rRoute
  '/auth/callback': typeof PublicAuthCallbackRoute
  '/auth/logg-inn': typeof PublicAuthLoggInnRoute
  '/auth/login': typeof PublicAuthLoginRoute
  '/auth/logout': typeof PublicAuthLogoutRoute
  '/dokumentasjon/eksporter': typeof PublicDokumentasjonEksporterRoute
  '/dokumentasjon/innrapportering': typeof PublicDokumentasjonInnrapporteringRoute
  '/maalerdata/periode': typeof AppSubheaderMaalerdataPeriodeRoute
  '/maalerdata/simulering': typeof AppSubheaderMaalerdataSimuleringRoute
  '/maalerdata/validering': typeof AppSubheaderMaalerdataValideringRoute
  '/fjern-avtale': typeof AppSubheaderFjernAvtaleIndexRoute
  '/maalerdata': typeof AppSubheaderMaalerdataIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/debug': typeof DebugRoute
  '/_app/_subheader': typeof AppSubheaderRouteRouteWithChildren
  '/_app/innstillinger': typeof AppInnstillingerRoute
  '/_app/selskap': typeof AppSelskapRoute
  '/_app/_subheader/bestillinger': typeof AppSubheaderBestillingerRoute
  '/_public/_landing/kundestøtte': typeof PublicLandingKundestChar248tteRoute
  '/_public/_landing/validering': typeof PublicLandingValideringRoute
  '/_public/_landing/veiledning': typeof PublicLandingVeiledningRoute
  '/_public/_landing/vilkår': typeof PublicLandingVilkChar229rRoute
  '/_public/auth/callback': typeof PublicAuthCallbackRoute
  '/_public/auth/logg-inn': typeof PublicAuthLoggInnRoute
  '/_public/auth/login': typeof PublicAuthLoginRoute
  '/_public/auth/logout': typeof PublicAuthLogoutRoute
  '/_public/dokumentasjon/eksporter': typeof PublicDokumentasjonEksporterRoute
  '/_public/dokumentasjon/innrapportering': typeof PublicDokumentasjonInnrapporteringRoute
  '/_public/_landing/': typeof PublicLandingIndexRoute
  '/_app/_subheader/maalerdata/periode': typeof AppSubheaderMaalerdataPeriodeRoute
  '/_app/_subheader/maalerdata/simulering': typeof AppSubheaderMaalerdataSimuleringRoute
  '/_app/_subheader/maalerdata/validering': typeof AppSubheaderMaalerdataValideringRoute
  '/_app/_subheader/fjern-avtale/': typeof AppSubheaderFjernAvtaleIndexRoute
  '/_app/_subheader/maalerdata/': typeof AppSubheaderMaalerdataIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/debug'
    | '/innstillinger'
    | '/selskap'
    | '/bestillinger'
    | '/kundestøtte'
    | '/validering'
    | '/veiledning'
    | '/vilkår'
    | '/auth/callback'
    | '/auth/logg-inn'
    | '/auth/login'
    | '/auth/logout'
    | '/dokumentasjon/eksporter'
    | '/dokumentasjon/innrapportering'
    | '/maalerdata/periode'
    | '/maalerdata/simulering'
    | '/maalerdata/validering'
    | '/fjern-avtale/'
    | '/maalerdata/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/debug'
    | '/innstillinger'
    | '/selskap'
    | '/bestillinger'
    | '/kundestøtte'
    | '/validering'
    | '/veiledning'
    | '/vilkår'
    | '/auth/callback'
    | '/auth/logg-inn'
    | '/auth/login'
    | '/auth/logout'
    | '/dokumentasjon/eksporter'
    | '/dokumentasjon/innrapportering'
    | '/maalerdata/periode'
    | '/maalerdata/simulering'
    | '/maalerdata/validering'
    | '/fjern-avtale'
    | '/maalerdata'
  id:
    | '__root__'
    | '/_app'
    | '/debug'
    | '/_app/_subheader'
    | '/_app/innstillinger'
    | '/_app/selskap'
    | '/_app/_subheader/bestillinger'
    | '/_public/_landing/kundestøtte'
    | '/_public/_landing/validering'
    | '/_public/_landing/veiledning'
    | '/_public/_landing/vilkår'
    | '/_public/auth/callback'
    | '/_public/auth/logg-inn'
    | '/_public/auth/login'
    | '/_public/auth/logout'
    | '/_public/dokumentasjon/eksporter'
    | '/_public/dokumentasjon/innrapportering'
    | '/_public/_landing/'
    | '/_app/_subheader/maalerdata/periode'
    | '/_app/_subheader/maalerdata/simulering'
    | '/_app/_subheader/maalerdata/validering'
    | '/_app/_subheader/fjern-avtale/'
    | '/_app/_subheader/maalerdata/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  DebugRoute: typeof DebugRoute
  PublicLandingKundestChar248tteRoute: typeof PublicLandingKundestChar248tteRoute
  PublicLandingValideringRoute: typeof PublicLandingValideringRoute
  PublicLandingVeiledningRoute: typeof PublicLandingVeiledningRoute
  PublicLandingVilkChar229rRoute: typeof PublicLandingVilkChar229rRoute
  PublicAuthCallbackRoute: typeof PublicAuthCallbackRoute
  PublicAuthLoggInnRoute: typeof PublicAuthLoggInnRoute
  PublicAuthLoginRoute: typeof PublicAuthLoginRoute
  PublicAuthLogoutRoute: typeof PublicAuthLogoutRoute
  PublicDokumentasjonEksporterRoute: typeof PublicDokumentasjonEksporterRoute
  PublicDokumentasjonInnrapporteringRoute: typeof PublicDokumentasjonInnrapporteringRoute
  PublicLandingIndexRoute: typeof PublicLandingIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/debug': {
      id: '/debug'
      path: '/debug'
      fullPath: '/debug'
      preLoaderRoute: typeof DebugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_subheader': {
      id: '/_app/_subheader'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppSubheaderRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/innstillinger': {
      id: '/_app/innstillinger'
      path: '/innstillinger'
      fullPath: '/innstillinger'
      preLoaderRoute: typeof AppInnstillingerRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/selskap': {
      id: '/_app/selskap'
      path: '/selskap'
      fullPath: '/selskap'
      preLoaderRoute: typeof AppSelskapRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/_subheader/bestillinger': {
      id: '/_app/_subheader/bestillinger'
      path: '/bestillinger'
      fullPath: '/bestillinger'
      preLoaderRoute: typeof AppSubheaderBestillingerRouteImport
      parentRoute: typeof AppSubheaderRouteRoute
    }
    '/_public/_landing/': {
      id: '/_public/_landing/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicLandingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/_landing/kundestøtte': {
      id: '/_public/_landing/kundestøtte'
      path: '/kundestøtte'
      fullPath: '/kundestøtte'
      preLoaderRoute: typeof PublicLandingKundestChar248tteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/_landing/validering': {
      id: '/_public/_landing/validering'
      path: '/validering'
      fullPath: '/validering'
      preLoaderRoute: typeof PublicLandingValideringRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/_landing/veiledning': {
      id: '/_public/_landing/veiledning'
      path: '/veiledning'
      fullPath: '/veiledning'
      preLoaderRoute: typeof PublicLandingVeiledningRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/_landing/vilkår': {
      id: '/_public/_landing/vilkår'
      path: '/vilkår'
      fullPath: '/vilkår'
      preLoaderRoute: typeof PublicLandingVilkChar229rRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/auth/callback': {
      id: '/_public/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof PublicAuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/auth/logg-inn': {
      id: '/_public/auth/logg-inn'
      path: '/auth/logg-inn'
      fullPath: '/auth/logg-inn'
      preLoaderRoute: typeof PublicAuthLoggInnRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/auth/login': {
      id: '/_public/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof PublicAuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/auth/logout': {
      id: '/_public/auth/logout'
      path: '/auth/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof PublicAuthLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/dokumentasjon/eksporter': {
      id: '/_public/dokumentasjon/eksporter'
      path: '/dokumentasjon/eksporter'
      fullPath: '/dokumentasjon/eksporter'
      preLoaderRoute: typeof PublicDokumentasjonEksporterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/dokumentasjon/innrapportering': {
      id: '/_public/dokumentasjon/innrapportering'
      path: '/dokumentasjon/innrapportering'
      fullPath: '/dokumentasjon/innrapportering'
      preLoaderRoute: typeof PublicDokumentasjonInnrapporteringRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_subheader/fjern-avtale/': {
      id: '/_app/_subheader/fjern-avtale/'
      path: '/fjern-avtale'
      fullPath: '/fjern-avtale/'
      preLoaderRoute: typeof AppSubheaderFjernAvtaleIndexRouteImport
      parentRoute: typeof AppSubheaderRouteRoute
    }
    '/_app/_subheader/maalerdata/': {
      id: '/_app/_subheader/maalerdata/'
      path: '/maalerdata'
      fullPath: '/maalerdata/'
      preLoaderRoute: typeof AppSubheaderMaalerdataIndexRouteImport
      parentRoute: typeof AppSubheaderRouteRoute
    }
    '/_app/_subheader/maalerdata/periode': {
      id: '/_app/_subheader/maalerdata/periode'
      path: '/maalerdata/periode'
      fullPath: '/maalerdata/periode'
      preLoaderRoute: typeof AppSubheaderMaalerdataPeriodeRouteImport
      parentRoute: typeof AppSubheaderRouteRoute
    }
    '/_app/_subheader/maalerdata/simulering': {
      id: '/_app/_subheader/maalerdata/simulering'
      path: '/maalerdata/simulering'
      fullPath: '/maalerdata/simulering'
      preLoaderRoute: typeof AppSubheaderMaalerdataSimuleringRouteImport
      parentRoute: typeof AppSubheaderRouteRoute
    }
    '/_app/_subheader/maalerdata/validering': {
      id: '/_app/_subheader/maalerdata/validering'
      path: '/maalerdata/validering'
      fullPath: '/maalerdata/validering'
      preLoaderRoute: typeof AppSubheaderMaalerdataValideringRouteImport
      parentRoute: typeof AppSubheaderRouteRoute
    }
  }
}

interface AppSubheaderRouteRouteChildren {
  AppSubheaderBestillingerRoute: typeof AppSubheaderBestillingerRoute
  AppSubheaderMaalerdataPeriodeRoute: typeof AppSubheaderMaalerdataPeriodeRoute
  AppSubheaderMaalerdataSimuleringRoute: typeof AppSubheaderMaalerdataSimuleringRoute
  AppSubheaderMaalerdataValideringRoute: typeof AppSubheaderMaalerdataValideringRoute
  AppSubheaderFjernAvtaleIndexRoute: typeof AppSubheaderFjernAvtaleIndexRoute
  AppSubheaderMaalerdataIndexRoute: typeof AppSubheaderMaalerdataIndexRoute
}

const AppSubheaderRouteRouteChildren: AppSubheaderRouteRouteChildren = {
  AppSubheaderBestillingerRoute: AppSubheaderBestillingerRoute,
  AppSubheaderMaalerdataPeriodeRoute: AppSubheaderMaalerdataPeriodeRoute,
  AppSubheaderMaalerdataSimuleringRoute: AppSubheaderMaalerdataSimuleringRoute,
  AppSubheaderMaalerdataValideringRoute: AppSubheaderMaalerdataValideringRoute,
  AppSubheaderFjernAvtaleIndexRoute: AppSubheaderFjernAvtaleIndexRoute,
  AppSubheaderMaalerdataIndexRoute: AppSubheaderMaalerdataIndexRoute,
}

const AppSubheaderRouteRouteWithChildren =
  AppSubheaderRouteRoute._addFileChildren(AppSubheaderRouteRouteChildren)

interface AppRouteRouteChildren {
  AppSubheaderRouteRoute: typeof AppSubheaderRouteRouteWithChildren
  AppInnstillingerRoute: typeof AppInnstillingerRoute
  AppSelskapRoute: typeof AppSelskapRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppSubheaderRouteRoute: AppSubheaderRouteRouteWithChildren,
  AppInnstillingerRoute: AppInnstillingerRoute,
  AppSelskapRoute: AppSelskapRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  DebugRoute: DebugRoute,
  PublicLandingKundestChar248tteRoute: PublicLandingKundestChar248tteRoute,
  PublicLandingValideringRoute: PublicLandingValideringRoute,
  PublicLandingVeiledningRoute: PublicLandingVeiledningRoute,
  PublicLandingVilkChar229rRoute: PublicLandingVilkChar229rRoute,
  PublicAuthCallbackRoute: PublicAuthCallbackRoute,
  PublicAuthLoggInnRoute: PublicAuthLoggInnRoute,
  PublicAuthLoginRoute: PublicAuthLoginRoute,
  PublicAuthLogoutRoute: PublicAuthLogoutRoute,
  PublicDokumentasjonEksporterRoute: PublicDokumentasjonEksporterRoute,
  PublicDokumentasjonInnrapporteringRoute:
    PublicDokumentasjonInnrapporteringRoute,
  PublicLandingIndexRoute: PublicLandingIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
